// eslint-disable-next-line no-nested-ternary
import React from "react";
import Skeleton from "react-loading-skeleton";

function TriggerLoader() {
  return (
    <div className="pp_trigger_box_loader">
      <div className="pp_trigger_box_to_holder">
        <Skeleton width={200} height={22} />
      </div>
      <Skeleton width={250} height={22} />
    </div>
  );
}

export default TriggerLoader;
